import PropTypes from 'prop-types'
import { mergeOverrides } from 'baseui'
import { ButtonGroup, SIZE } from 'baseui/button-group'
import { SDButtonGroupOverrides } from './styled-components'
import { SDButtonGroupPulseOverrides } from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const SDButtonGroup = ({ children, direction, error, size, overrides, ...rest }) => {
  const isPulse = usePulseScope()
  const baseOverrides = isPulse
    ? SDButtonGroupPulseOverrides(direction, error)
    : SDButtonGroupOverrides(direction, error)
  const newOverrides = mergeOverrides(baseOverrides, overrides)
  return (
    <ButtonGroup {...rest} size={size ?? SIZE.compact} overrides={newOverrides}>
      {children}
    </ButtonGroup>
  )
}

SDButtonGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  direction: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  overrides: PropTypes.object,
  size: PropTypes.string,
}

export default SDButtonGroup
